/**
 * Cart added popup – Figma 6510-20960
 * Shown when add-to-cart succeeds from collection/search/product card.
 * Implements same interface as cart-notification/cart-drawer for product-form.
 * Also intercepts OOO add-to-cart forms (data-add-to-cart-show-popup) so they never redirect.
 */
(function () {
  function getSectionInnerHTML(html, selector) {
    const sel = selector || ".shopify-section";
    const doc = new DOMParser().parseFromString(html, "text/html");
    const el = doc.querySelector(sel);
    return el ? el.innerHTML : "";
  }

  function formatMoney(cents) {
    if (typeof cents !== "number") return "";
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat(window.Shopify?.locale || "en", {
      style: "currency",
      currency: window.Shopify?.currency?.active || "USD",
    }).format(cents / 100);
  }

  function handleOooAddToCartSubmit(evt) {
    const form = evt.target;
    if (!form || form.tagName !== "FORM") return;
    if (
      !form.hasAttribute("data-add-to-cart-show-popup") &&
      !form.classList.contains("collection-product-grid__add-to-cart-form")
    )
      return;
    if (form.closest("product-form")) return;
    // Opt-out: section can mark forms with data-sl-suppress-popup to handle add-to-cart itself.
    if (form.hasAttribute("data-sl-suppress-popup")) return;
    evt.preventDefault();
    evt.stopPropagation();

    const popupEl = document.querySelector("cart-added-popup");
    if (!popupEl || typeof popupEl.renderContents !== "function") return;

    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute("aria-disabled", "true");
    }

    const config =
      typeof fetchConfig === "function"
        ? fetchConfig("javascript")
        : { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest" } };
    delete config.headers["Content-Type"];
    const formData = new FormData(form);
    formData.append("sections", "cart-icon-bubble,cart-drawer");
    formData.append("sections_url", window.location.pathname);
    config.body = formData;

    fetch(
      window.routes && window.routes.cart_add_url
        ? window.routes.cart_add_url
        : "/cart/add.js",
      config,
    )
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          if (data.description) alert(data.description);
          return;
        }
        popupEl.renderContents(data);
      })
      .catch(function (err) {
        console.error(err);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute("aria-disabled");
        }
      });
  }

  document.addEventListener("submit", handleOooAddToCartSubmit, true);

  class CartAddedPopup extends HTMLElement {
    constructor() {
      super();
      this.popup = document.getElementById("cart-added-popup");
      this.overlay = document.getElementById("cart-added-popup-overlay");
      if (!this.popup || !this.overlay) return;

      this.popup.addEventListener("keydown", (e) => {
        if (e.code === "Escape") this.close();
      });
      this.querySelector(".cart-added-popup__close").addEventListener(
        "click",
        () => this.close(),
      );
      this.overlay.addEventListener("click", () => this.close());
    }

    open() {
      // Popup suppressed: the cart drawer opens on add-to-cart and shows the
      // updated cart, so the popup is redundant.
      return;
    }

    close() {
      this.removeAttribute("open");
      this.popup.setAttribute("hidden", "");
      this.overlay.setAttribute("aria-hidden", "true");
      if (typeof removeTrapFocus === "function" && this.activeElement) {
        removeTrapFocus(this.activeElement);
      }
    }

    setActiveElement(el) {
      this.activeElement = el;
    }

    getSectionsToRender() {
      return [{ id: "cart-icon-bubble" }, { id: "cart-drawer" }];
    }

    renderContents(parsedState) {
      if (!this.popup) return;

      // Update cart icon bubble if we have section HTML
      const bubbleSection =
        parsedState.sections && parsedState.sections["cart-icon-bubble"];
      if (bubbleSection) {
        const bubbleEl = document.getElementById("cart-icon-bubble");
        if (bubbleEl) {
          bubbleEl.innerHTML = getSectionInnerHTML(bubbleSection);
        }
      }

      // Update cart drawer items so they reflect the new addition without a page refresh
      const cartDrawerEl = document.querySelector("cart-drawer");
      if (
        cartDrawerEl &&
        typeof cartDrawerEl.renderContents === "function" &&
        parsedState.sections &&
        parsedState.sections["cart-drawer"]
      ) {
        cartDrawerEl.renderContents(parsedState);
      }

      // Resolve added item: from cart items array or from single-item response
      const items = parsedState.items || [];
      const addedKey = parsedState.key;
      let item = null;
      if (items.length > 0) {
        item = addedKey
          ? items.find(function (i) {
              return i.key === addedKey;
            })
          : items[items.length - 1];
      }
      if (
        !item &&
        (parsedState.product_title != null || parsedState.title != null)
      ) {
        item = parsedState;
      }

      const imgEl = this.popup.querySelector(
        ".cart-added-popup__product-image",
      );
      const nameEl = this.popup.querySelector(
        ".cart-added-popup__product-name",
      );
      const variantEl = this.popup.querySelector(
        ".cart-added-popup__product-variant",
      );
      const priceEl = this.popup.querySelector(
        ".cart-added-popup__product-price",
      );
      const totalEl = this.popup.querySelector(
        ".cart-added-popup__total-money",
      );
      const imageWrap =
        imgEl && imgEl.closest(".cart-added-popup__product-image-wrap");

      if (item) {
        var imgUrl = null;
        if (typeof item.image === "string" && item.image) {
          imgUrl = item.image;
        } else if (item.image && item.image.url) {
          imgUrl = item.image.url;
        } else if (item.featured_image && item.featured_image.url) {
          imgUrl = item.featured_image.url;
        } else if (
          item.featured_image &&
          typeof item.featured_image === "string"
        ) {
          imgUrl = item.featured_image;
        }
        if (imgEl) {
          if (imgUrl) {
            imgEl.src = imgUrl;
            imgEl.alt = item.product_title || item.title || "";
            if (imageWrap) imageWrap.style.display = "";
          } else {
            if (imageWrap) imageWrap.style.display = "none";
          }
        }
        if (nameEl) nameEl.textContent = item.product_title || item.title || "";
        if (variantEl) {
          var variantTitle =
            item.variant_title && item.variant_title !== "Default Title"
              ? item.variant_title
              : "";
          variantEl.textContent = variantTitle;
          variantEl.style.display = variantTitle ? "" : "none";
        }
        if (priceEl)
          priceEl.textContent = formatMoney(
            item.final_line_price || item.line_price || item.price || 0,
          );
        if (totalEl)
          totalEl.textContent = formatMoney(
            parsedState.total_price ||
              item.final_line_price ||
              item.line_price ||
              item.price ||
              0,
          );
      } else {
        if (nameEl) nameEl.textContent = "";
        if (variantEl) {
          variantEl.textContent = "";
          variantEl.style.display = "none";
        }
        if (priceEl) priceEl.textContent = "";
        if (totalEl)
          totalEl.textContent = formatMoney(parsedState.total_price || 0);
        if (imgEl) {
          imgEl.src = "";
          imgEl.alt = "";
        }
        if (imageWrap) imageWrap.style.display = "";
      }

      var form = document.getElementById("cart-added-popup-checkout-form");
      if (form)
        form.action =
          window.routes && window.routes.cart_url
            ? window.routes.cart_url
            : "/cart";

      this.open();
    }
  }

  customElements.define("cart-added-popup", CartAddedPopup);
})();
